import { Box } from '@mui/material'
import React, { useMemo } from 'react'
import moment from 'moment'
import isEqual from 'lodash/isEqual'
import { generatePath } from '@/lib/urlParse'
import TrendTable from './components/trendTable'
import { getCurrency } from '../../lib/currency'
import { BED_ROOMS_INFO_LIST } from './constData'

const dataFormat = (data, cityName: string, areaName: string) => {
  const prefixPath = generatePath(cityName, areaName)
  const newData = []
  if (Array.isArray(data)) {
    // const orderList = Object.keys(typeMap)
    BED_ROOMS_INFO_LIST.forEach(({ apartmentType, key, label, path }, index) => {
      const currentItem =
        data.find((item = {}) => String(item.apartmentType) === String(apartmentType)) || {}
      const {
        apartmentAnnual: annualChange,
        apartmentAvgRent: avgRent,
        apartmentAvgSqft: averageSqFt
      } = currentItem
      newData.push({
        key,
        annualChange,
        avgRent,
        averageSqFt,
        label,
        href: `${prefixPath}/${path}`,
        index
      })
    })
  }
  return newData
}

const AverageRent = ({ dataSource = [], averageRent, filterBy, className = '', isPC = false }) => {
  const { city: cityName, area: areaName } = filterBy || {}
  const { avgRent, updateTime } = averageRent || {}

  const cityAreaStr = useMemo(
    () => [cityName, areaName].filter(e => e).join(', '),
    [cityName, areaName]
  )

  const options = useMemo(
    () => [
      {
        dataIndex: 'label',
        title: isPC ? 'Apartment Type' : 'Apt. Type',
        render: ({ label, href }) => (
          <Box
            component="a"
            className="text-xs lg:text-base font-semibold cursor-pointer underline"
            href={href}
          >
            {label}
          </Box>
        )
      },
      {
        dataIndex: 'avgRent',
        title: 'Avg Rent',
        render: ({ avgRent: _avgRent }) => (
          <Box className="text-xs lg:text-base">
            ${getCurrency(_avgRent, 0) || '--'}/{isPC ? 'month' : 'mo'}
          </Box>
        )
      },
      {
        dataIndex: 'averageSqFt',
        title: isPC ? 'Average Sq.Ft' : 'Avg Sq.Ft',
        render: ({ averageSqFt }) => (
          <Box className="text-xs lg:text-base">{getCurrency(averageSqFt, 0) || '--'} Sq.Ft</Box>
        )
      },
      {
        dataIndex: 'annualChange',
        title: isPC ? 'Annual Change' : 'YoY',
        render: ({ annualChange }) => {
          // 非NaN：true
          const isValidValue = !Number.isNaN(parseFloat(annualChange)) && annualChange !== '0.0'
          return (
            <Box className="text-xs lg:text-base">
              {isValidValue && parseFloat(annualChange) > 0 ? '+' : ''}
              {isValidValue ? `${(parseFloat(annualChange) * 100).toFixed(1)}%` : '--'}
            </Box>
          )
        }
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isPC]
  )
  const rowsData = useMemo(
    () => dataFormat(dataSource, cityName, areaName),
    [dataSource, cityName, areaName]
  )

  return (
    <Box className={className}>
      <Box
        component="h3"
        className="text-[22px] leading-8 font-bold text-primary capitalize pl-5 -indent-5"
      >
        1. Average Rent For Different Apartment Types
      </Box>
      <Box className="text-base my-6">
        As of {updateTime ? moment(updateTime).format('MMMM YYYY') : '--'}, the average rent in{' '}
        {cityAreaStr} was ${getCurrency(avgRent, 0) || '--'}/month.
        {cityName === 'Los Angeles'
          ? 'When you rent an apartment in Los Angeles, you can expect to pay as little as $1,894 to as much as $2,492, depending on the location and size of the apartment.'
          : ''}
      </Box>
      {rowsData.length > 0 ? (
        <Box className="w-full">
          <TrendTable dataList={rowsData} options={options} />
        </Box>
      ) : null}
    </Box>
  )
}

export default React.memo(AverageRent, (pre, nxt) => isEqual(pre, nxt))
